import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/capture-dashboard/widgets/recent-activity";
const LIMIT = 5;

export const fetchRecentActivity = createAsyncThunk(
  "recentActivity/fetch",
  async (_, { getState }) => {
    const { filters } = getState().capture.dashboard;
    const { periodStart, periodEnd } = resolvePeriod(filters);

    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd, limit: LIMIT },
    });
    return data;
  },
);
